export default "__VITE_ASSET__zSLjkS_J__"